/*
 *   Copyright (c) 2021
 *   All rights reserved.
 */
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import { persistReducer } from 'redux-persist';
import { ACTION_TYPES } from './Home.action';

const initialState = {
    upComing: [],
};

const homeReducer = (state = initialState, action: { type: string; payload: any }) => {
    switch (action.type) {
        case ACTION_TYPES.GET_UPCOMING_PROJECT:
            return { ...state, upComing: action.payload };
            break;
        case ACTION_TYPES.GET_DATA_REPORT:
            return {
                ...state,
                TradingVolume: action.payload.trading_volume24h,
                TotalBurn: action.payload.total_burn,
                TotalLock: action.payload.total_lock,
                StakingPool: action.payload.staking_pool,
            };
        default:
            return state;
    }
};

const persistConfig = {
    key: 'homeReducer',
    storage,
    stateReconciler: autoMergeLevel2,
};

export default persistReducer(persistConfig, homeReducer);
